import React from 'react';
import { ShowIf } from 'components/utils';
import {msg} from "constants/message";
import {validatable} from 'components/utils';

class InputPassword extends React.Component {
  constructor(props, context) {
    super(props, context);

    this.state = {
      newPassword: this.props.newPassword || '',
      passwordConfirmation: this.props.passwordConfirmation || '',
      value: this.props.value,
      isValid: true
    }
  }

  onChange(e) {
    this.setState({
      value: e.target.value
    });

    this.props.onChange(e);
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.value != nextProps.value) {
      this.setState({
        value: nextProps.value
      });
      if(nextProps.require && nextProps.value.trim()) {
        this.setState({
          isValid: true
        });
      }
    }
  }

  classNames() {
    if (this.state.isValid) {
      return 'pt-input';
    } else {
      return 'pt-input pt-intent-danger';
    }
  }

  validate() {
    if (this.state.value.trim() == '' && this.props.require) {
      this.setState({
        isValid: false
      });
      this.input.focus();
      return false;
    } else {
      this.setState({
        isValid: true
      });
      return true;
    }
  }

  render() {
    return (
      <div className={this.props.className + ' mb18'}>
        <label className="ip-label">
          { this.props.label }
          <ShowIf condition={this.props.require}>
            <span className="text-required">&nbsp;*</span>
          </ShowIf>
        </label>
        <input type="password" className={ this.classNames() } ref={(input) => {this.input = input}} maxLength={this.props.maxLength} value={this.state.value} onChange={ this.onChange.bind(this) } placeholder={this.props.placeholder}/>
        <ShowIf condition={!this.state.isValid && this.state.value.trim()== ''}>
          <div className="pt-form-helper-text">{msg.messageDefault}</div>
        </ShowIf>
      </div>
    );
  }
}

InputPassword.defaultProps = {
  type: '',
  className: 'input-group',
  label: '',
  onChange: function() {
    console.log('Need to assign onChange method');
  },
  placeholder: null,
  require: false,
  maxLength: 255
}

export default validatable(InputPassword);



// WEBPACK FOOTER //
// ./src/components/tt-forms/common/InputPassword.jsx